import React from 'react';
import { LayoutState } from './types';

export const LayoutContext = React.createContext<LayoutState | undefined>(
  undefined
);

export const useLayout = () => {
  const context = React.useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
